import { apiFetch } from './client';
import type { BollettaApiDetail, BolletteListResponse } from '@/types';

export function getBollette(limit = 50, offset = 0): Promise<BolletteListResponse> {
  const qs = new URLSearchParams({ limit: String(limit), offset: String(offset) });
  return apiFetch<BolletteListResponse>(`/espo/bollette?${qs.toString()}`);
}

export function getBolletta(id: string): Promise<BollettaApiDetail> {
  return apiFetch<BollettaApiDetail>(`/espo/bollette/${encodeURIComponent(id)}`);
}

/** Scarica il file binario di una bolletta e triggera download nel browser.
 * Lancia Error("File non disponibile") su 404 e Error("Errore download") su altro.
 */
export async function downloadBollettaFile(id: string, filename: string, staff = false): Promise<void> {
  const base = staff ? '/api/espo/agenzia/bollette' : '/api/espo/bollette';
  const res = await fetch(`${base}/${encodeURIComponent(id)}/file`, {
    credentials: 'include',
  });
  if (res.status === 404) {
    throw new Error('File non disponibile');
  }
  if (!res.ok) {
    throw new Error('Errore download');
  }
  // Usa il filename dal Content-Disposition del backend (contiene .zip se multipli)
  const cd = res.headers.get('Content-Disposition');
  const cdMatch = cd?.match(/filename="?([^"]+)"?/);
  const actualFilename = cdMatch?.[1] || filename;

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = actualFilename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
